var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-drawer",
    {
      staticClass: "app-drawer",
      attrs: { id: "app-drawer", placement: "start" },
    },
    [
      _c(
        "div",
        { attrs: { slot: "label" }, slot: "label" },
        [_c("page-header-products", { attrs: { "is-full": false } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "display-flex flex-column",
          staticStyle: { gap: "var(--spacing-3xl)" },
        },
        [
          _c(
            "div",
            [
              _c(
                "site-link",
                {
                  staticClass:
                    "button flat clear with-border margin-bottom-lg display-flex flex-items-center rounded",
                  staticStyle: {
                    "--button-hover-color": "var(--link-color)",
                    "--border-color": "var(--fa-navy)",
                    "--button-hover-border-color": "var(--fa-navy)",
                    "box-shadow": "var(--input-box-shadow)",
                    "border-radius": "var(--border-radius-pill)",
                    gap: "var(--spacing-sm)",
                  },
                  attrs: {
                    to: _vm.routes.search.location,
                    "data-drawer": "close",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture(
                        "main_navigation_link_click",
                        {
                          destination: "icon_search",
                          context: "responsive_menu",
                        }
                      )
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticStyle: { color: "var(--fa-navy)" },
                    attrs: { icon: _vm.$v7.solid.faMagnifyingGlass },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "size-sm" }, [
                    _vm._v(
                      "Search " +
                        _vm._s(_vm.$counts.icons.all.formatted) +
                        " icons…"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "outline size-sm display-flex flex-column",
                  staticStyle: { gap: "var(--spacing-xs)" },
                },
                [
                  _c(
                    "li",
                    [
                      _vm.$account
                        ? _c(
                            "site-link",
                            {
                              staticClass:
                                "display-flex flex-items-center padding-y-2xs no-underline",
                              staticStyle: { gap: "var(--spacing-sm)" },
                              attrs: {
                                to: _vm.routes.kits.location,
                                "data-drawer": "close",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.$posthog.capture(
                                    "main_navigation_link_click",
                                    {
                                      destination: "kits",
                                      context: "responsive_menu",
                                    }
                                  )
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.$v7.solid.faBriefcase,
                                  size: "lg",
                                },
                              }),
                              _vm._v("\n            Your Kits\n          "),
                            ],
                            1
                          )
                        : _c(
                            "site-link",
                            {
                              staticClass:
                                "display-flex flex-items-center padding-y-2xs no-underline",
                              staticStyle: { gap: "var(--spacing-sm)" },
                              attrs: {
                                to: _vm.routes.start.location,
                                "data-drawer": "close",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.$posthog.capture(
                                    "main_navigation_link_click",
                                    {
                                      destination: "start",
                                      context: "responsive_menu",
                                    }
                                  )
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: _vm.$v7.solid.faRocketLaunch,
                                  size: "lg",
                                },
                              }),
                              _vm._v("\n            Get Started\n          "),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "site-link",
                        {
                          staticClass:
                            "display-flex flex-items-center padding-y-2xs no-underline",
                          staticStyle: { gap: "var(--spacing-sm)" },
                          attrs: {
                            to: _vm.routes.icons.location,
                            "data-drawer": "close",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.$posthog.capture(
                                "main_navigation_link_click",
                                {
                                  destination: "icons",
                                  context: "responsive_menu",
                                }
                              )
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faIcons, size: "lg" },
                          }),
                          _vm._v("\n            Icons\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "site-link",
                        {
                          staticClass:
                            "display-flex flex-items-center padding-y-2xs no-underline",
                          staticStyle: { gap: "var(--spacing-sm)" },
                          attrs: {
                            to: _vm.routes.docs.location,
                            "data-drawer": "close",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.$posthog.capture(
                                "main_navigation_link_click",
                                {
                                  destination: "docs",
                                  context: "responsive_menu",
                                }
                              )
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faBook, size: "lg" },
                          }),
                          _vm._v("\n            Documentation\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "site-link",
                        {
                          staticClass:
                            "display-flex flex-items-center padding-y-2xs no-underline",
                          staticStyle: { gap: "var(--spacing-sm)" },
                          attrs: {
                            to: _vm.routes.plans.location,
                            "data-drawer": "close",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.$posthog.capture(
                                "main_navigation_link_click",
                                {
                                  destination: "plans",
                                  context: "responsive_menu",
                                }
                              )
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.$v7.solid.faPlanetRinged,
                              size: "lg",
                            },
                          }),
                          _vm._v("\n            Plans\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "site-link",
                        {
                          staticClass:
                            "display-flex flex-items-center padding-y-2xs no-underline",
                          staticStyle: { gap: "var(--spacing-sm)" },
                          attrs: {
                            to: _vm.routes.support.location,
                            "data-drawer": "close",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.$posthog.capture(
                                "main_navigation_link_click",
                                {
                                  destination: "support",
                                  context: "responsive_menu",
                                }
                              )
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.$v7.solid.faHeadset,
                              size: "lg",
                            },
                          }),
                          _vm._v("\n            Support\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", {
            staticStyle: {
              "--hr-border-width": "var(--border-width-xs)",
              "--hr-border-color": "var(--fa-lt-gravy)",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "display-flex flex-column",
              staticStyle: { gap: "var(--spacing-xl)" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "display-flex flex-column muted",
                  staticStyle: { gap: "var(--spacing-md)" },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "awesome-logo logo-font-awesome",
                    attrs: { icon: _vm.$v7.brands.faFontAwesome },
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "size-sm margin-y-0" }, [
                    _vm._v("Font Awesome"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "size-xs muted" }, [
                    _vm._v("© Fonticons, Inc."),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "display-flex flex-items-center size-sm",
              staticStyle: { gap: "var(--spacing-md)" },
            },
            [
              _c("h2", { staticClass: "sr-only" }, [
                _vm._v("Font Awesome Elsewhere"),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://github.com/fortawesome/Font-Awesome",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "GitHub",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.brands.faGithub },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://www.podcastawesome.com",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "Podcast Awesome",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.solid.faPodcast },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://www.youtube.com/@font.awesome",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "YouTube",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.brands.faYoutube },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://bsky.app/profile/fontawesome.com",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "Bluesky",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.brands.faBluesky },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://mastodon.social/@webawesome",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "Mastodon",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.brands.faMastodon },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://x.com/fontawesome",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "Twitter (X)",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.brands.faXTwitter },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link no-underline plain",
                  attrs: {
                    href: "https://www.threads.com/@font.awesome",
                    rel: "noopener noreferrer",
                    target: "_blank",
                    "aria-label": "Threads",
                  },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.brands.faThreads },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }